// extracted by mini-css-extract-plugin
export var addressFields = "_oh-0";
export var animationContainer = "_oh-1";
export var footer = "_oh-2";
export var lineItems = "_oh-3";
export var modalContent = "_oh-4";
export var orderName = "_oh-5";
export var strong = "_oh-6";
export var warning = "_oh-7";